export var PUBLICKEY_RECOVERY_MESSAGE = 'By signing this message you are allowing access to your public key';
export var STD_ERRORS = {
  CANCEL_MSG_SIGN: 'User denied message signature',
  CANCEL_TX_SIGN: 'User denied transaction signature'
};